import React, { useState, useCallback, useEffect } from 'react';
import { Switch } from '@ds/ui'; 
import { apiFetch, handleApiError } from '../../utils/apiClient';

interface StatusOption {
  value: string;
  label: string;
}

const statusOptions: StatusOption[] = [
  { value: 'Server Up', label: 'Server Up' },
  { value: 'Server Down', label: 'Server Down' },
];

export default function StatusUpdateComponent() {
  const [status, setStatus] = useState<string>('Server Up');
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const fetchInitialStatus = useCallback(async () => {
    try {
      const response = await fetch('Admin/Home/GetApplianceStatus');
      const data = await response.json();
      setStatus(data.applianceStatus);
    } catch (err) {
      console.error('Error fetching initial status:', err);
      setError('Failed to load initial status');
    }
  }, []);

  useEffect(() => {
    fetchInitialStatus();
  }, [fetchInitialStatus]);

  const handleSwitchChange = useCallback(async (event: React.ChangeEvent<HTMLInputElement>) => {
    const checked = event.target.checked;
    const newStatus = checked ? 'Server Up' : 'Server Down';
    setStatus(newStatus);
    setIsLoading(true);
    setError(null);
    
    try {
      const response = await apiFetch('Admin/Home/UpdateStatus', {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ status: newStatus })
      });
      if (!response.ok) {
        await handleApiError(response);
      }
      const data = await response.json();
      setStatus(data.applianceStatus);
    } catch (err) {
      console.error('Error updating status:', err);
      setError('Failed to update status');
      // Revert to previous status on error
      setStatus(checked ? 'Server Down' : 'Server Up');
    } finally {
      setIsLoading(false);
    }
  }, []);

  return (
    <div style={{ display: 'flex', alignItems: 'center' }}>
      <Switch
        key="Status"
        label={status}
        onChange={handleSwitchChange}
        on={status === 'Server Up'}
        disabled={isLoading}
      />
      {error && <div style={{ color: 'red', marginLeft: '0.625rem' }}>{error}</div>}
    </div>
  );
}
